__turbopack_context__.v({
  "button": "styles-module__oMHRLG__button",
  "icon": "styles-module__oMHRLG__icon",
  "visible": "styles-module__oMHRLG__visible",
});
